import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Linkuri utile */}
        <div className="footer-column">
          <h2 className="footer-title">GPDR</h2>
          <ul className="footer-list">
            <li className="footer-list-item">
              <a href="/termeni" className="footer-link">
                Termeni și condiții
              </a>
            </li>
            <li className="footer-list-item">
              <a href="/politica" className="footer-link">
                Politica de confidențialitate
              </a>
            </li>
            <li className="footer-list-item">
              <a href="/contact" className="footer-link">
                Contact
              </a>
            </li>
            <li className="footer-list-item">
              <a href="https://reclamatiisal.anpc.ro/" className="footer-link">
                ANPC
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h2 className="footer-title">Linkuri utile</h2>
          <ul className="footer-list">
            <li className="footer-list-item">
              <a href="/" className="footer-link">
                Acasa
              </a>
            </li>
            <li className="footer-list-item">
              <a href="/stock" className="footer-link">
                Stoc Mașini
              </a>
            </li>
            <li className="footer-list-item">
              <a href="/contact" className="footer-link">
                Contact
              </a>
            </li>
            <li className="footer-list-item">
              <a href="https://wa.me/40770905087" className="footer-link">
                WhatsApp
              </a>
            </li>
            <li className="footer-list-item">
              <a href="tel:+40770905087" className="footer-link">
                Sună acum!
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h2 className="footer-title">Contact</h2>
          <ul className="footer-list">
            <li className="footer-list-item">
              <a href="tel:+40760559464" className="footer-link">
                +40 (0760) 559 464
              </a>
            </li>
            <li className="footer-list-item">
              <a href="tel:+40770905087" className="footer-link">
                +40 (0770) 905 087
              </a>
            </li>
            <li className="footer-list-item">
              <span className="footer-link">Buzau</span>
            </li>
          </ul>
        </div>

        {/* Imagini SAL & SOL */}
        <div className="footer-column footer-images">
          <a 
            href="https://anpc.ro/ce-este-sal/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img
              className="footer-image"
              src="https://simpixel.ro/wp-content/uploads/2022/09/SAL.svg"
              alt="SAL"
            />
          </a>
          <a 
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img
              className="footer-image"
              src="https://simpixel.ro/wp-content/uploads/2022/09/SOL.svg"
              alt="SOL"
            />
          </a>
           {/* Social Media Icons */}
          <div className="footer-social">
            <a 
  href="https://www.facebook.com/share/1BmUwUsQeu/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="footer-social-link"
  aria-label="Facebook"
>
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className="footer-social-icon"
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
</a>
            <a 
              href="https://www.tiktok.com/@dlc.autocenter" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="TikTok"
            >
              <svg 
                viewBox="0 0 24 24" 
                fill="currentColor" 
                className="footer-social-icon"
              >
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} <a href="https://pret-site.ro/">dlc-auto-finance.ro</a> || Site realizat de pret-site.ro <a href="tel:+40762057825">+40762057825</a> Toate drepturile rezervate.
      </div>
    </footer>
  );
};

export default Footer;